<template>
	<Card>
		<div class="yl-flex">
			<div class="yl-flex" style="width: 380px">
				<Input v-model="name" style="width: 250px" placeholder="请输入名称">
				<i-button slot="append" icon="ios-search"></i-button>
				</Input>
				<Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
				<Button class='ivu-btn-circle' @click="initSearch">重置</Button>
			</div>
			<Button class='ivu-btn-circle' type="primary" @click="addPlatform">添加平台</Button>
		</div>
		<div style="margin-top: 20px;">
			<Table size="small" :columns="columns" :data="data">
				<template slot-scope="{ row }" slot="action">
					<Button class='ivu-btn-circle' :data-id="row.id" @click="editPlatform" type="warning"
						size="small">编辑</Button>
					<Button class='ivu-btn-circle' :data-id="row.id" @click="delPlatform" style="margin-left: 10px"
						size="small">删除</Button>
				</template>
			</Table>
			<div class="pager">
				<Page :total="count" :page-size="20" :current="page" @on-change="changePage" size="small" show-total
					show-elevator />
			</div>
		</div>
		<!-- 添加平台 -->
		<Modal v-model="modal" width="700">
			<div class="add_flex">
				<div class="add_title">平台名称</div>
				<Input v-model="addPlatformForm.name" style="width:200px" />
				<div class="add_title">结算后台账号</div>
				<Input v-model="addPlatformForm.phone" :disabled="addPlatformForm.phone_readonly"
					placeholder="请输入手机号(无佣金结算不用填写)" style="width:230px" />
			</div>
			<div class="add_flex">
				<div class="add_title">佣金计算方式</div>
				<RadioGroup v-model="addPlatformForm.settle_type">
					<Radio :label="1"><span>放款提成</span></Radio>
					<Radio :label="2"><span>客户进线数</span></Radio>
				</RadioGroup>
				<div class="add_flex" v-if="addPlatformForm.settle_type == 1">
					<div class="add_title">结算比例</div>
					<Input v-model="addPlatformForm.settle_proportion" style="width:90px">
					<span slot="append">%</span>
					</Input>
				</div>
				<div class="add_flex" v-if="addPlatformForm.settle_type == 2">
					<div class="add_title">结算单价</div>
					<Input v-model="addPlatformForm.settle_money" style="width:140px">
					<span slot="append">元/条</span>
					</Input>
				</div>
			</div>
			<div class="add_flex">
				<div class="add_title">平台类型</div>
				<RadioGroup v-model="addPlatformForm.platform_type">
					<Radio :label="1"><span>信息流投放</span></Radio>
					<Radio :label="2"><span>引流</span></Radio>
				</RadioGroup>
				<div class="add_title">进线撞库开关</div>
				<RadioGroup v-model="addPlatformForm.repeat_check">
					<Radio :label="1"><span>开</span></Radio>
					<Radio :label="-1"><span>关</span></Radio>
				</RadioGroup>
			</div>
			<div class="add_flex">
				<div class="add_title">入库条件</div>
				<RadioGroup v-model="addPlatformForm.condition_check">
					<Radio :label="1"><span>开</span></Radio>
					<Radio :label="-1"><span>关</span></Radio>
				</RadioGroup>
			</div>
			<div class="add_box" v-show="addPlatformForm.condition_check == 1">
				<div class="add_flex">
					<div style="height: 32px ; display: flex; align-items: center;">
						<div class="add_title">年龄要求</div>
						<RadioGroup v-model="addPlatformForm.condition.age_check">
							<Radio :label="1"><span>开</span></Radio>
							<Radio :label="-1"><span>关</span></Radio>
						</RadioGroup>
					</div>
					<div style="display: flex; align-items: center;"
						v-show="addPlatformForm.condition.age_check == '1' ">
						<div class="add_title">最低年龄</div>
						<Input v-model="addPlatformForm.condition.age_min" style="width:100px" />
						<div class="add_title">最高年龄</div>
						<Input v-model="addPlatformForm.condition.age_max" style="width:100px" />
					</div>
				</div>
				<div class="add_flex">
					<div style="height: 32px; display: flex; align-items: center;">
						<div class="add_title">贷款金额限制</div>
						<RadioGroup v-model="addPlatformForm.condition.loan_astrict">
							<Radio :label="1"><span>开</span></Radio>
							<Radio :label="-1"><span>关</span></Radio>
						</RadioGroup>
					</div>
					<div style="display: flex; align-items: center;"
						v-show="addPlatformForm.condition.loan_astrict == '1'">
						<div class="add_title">最低申请额度</div>
						<Input v-model="addPlatformForm.condition.money_min" style="width:200px">
						<span slot="append">元以上</span>
						</Input>
					</div>
				</div>
				<div class="add_flex">
					<div style="height: 32px; display: flex; align-items: center;">
						<div class="add_title">多选准入要求</div>
						<RadioGroup v-model="addPlatformForm.condition.entry_requirements">
							<Radio :label="1"><span>开</span></Radio>
							<Radio :label="-1"><span>关</span></Radio>
						</RadioGroup>
					</div>
					<div>(有一项条件即可准入)</div>
				</div>
				<CheckboxGroup v-model="addPlatformForm.condition.requirement"
					v-show="addPlatformForm.condition.entry_requirements == 1">
					<div style="display: flex; flex-direction: column; margin-left: 10px;">
						<Checkbox label="1"><span>全款房</span></Checkbox>
						<Checkbox label="2"><span>月供房</span></Checkbox>
						<Checkbox label="3"><span>全款车</span></Checkbox>
						<Checkbox label="4"><span>月供车</span></Checkbox>
						<Checkbox label="5"><span>公积金</span></Checkbox>
						<Checkbox label="6"><span>社保</span></Checkbox>
						<Checkbox label="7"><span>代发工资</span></Checkbox>
						<Checkbox label="8"><span>保单</span></Checkbox>
						<Checkbox label="9"><span>企业主</span></Checkbox>
						<Checkbox label="10"><span>个体户</span></Checkbox>
						<Checkbox label="11"><span>公职人员</span></Checkbox>
						<Checkbox label="12"><span>上班族</span></Checkbox>
						<Checkbox label="13"><span>微粒贷</span></Checkbox>
						<Checkbox label="14"><span>信用卡</span></Checkbox>
						<Checkbox label="15"><span>芝麻信用</span></Checkbox>
					</div>
				</CheckboxGroup>
			</div>
			<div class="add_flex">
				<div class="add_title">备注</div>
				<Input v-model="addPlatformForm.ext_info.remark" style="width:600px" />
			</div>
			<div slot="footer">
				<Button type="primary" @click="save()">保存</Button>
			</div>
		</Modal>
	</Card>
</template>

<script>
	import {
		saveMedium,
		getMediumList,
		getMedium,
		delMedium
	} from '@/api/runSet'
	import {
		mapGetters,
		mapActions
	} from "vuex";

	export default {
		name: "MediaPlatform",
		components: {},
		computed: {
			...mapGetters(['userInfo', 'token']),
		},
		created() {
			this.getList();
		},
		data() {
			return {
				count: 0,
				page: 1,
				modal: false,
				addPlatformForm: {
					phone_readonly: false,
					name: '',
					phone: '',
					settle_type: 1,
					settle_proportion: '',
					settle_money: '',
					platform_type: 1,
					repeat_check: -1,
					condition_check: -1,
					ext_info: {
						remark: '',
					},
					condition: {
						age_check: -1,
						age_min: '',
						age_max: '',
						loan_astrict: -1,
						money_min: '',
						entry_requirements: -1,
						requirement: [],
					},
				},
				name: '',
				columns: [{
						title: '媒体ID',
						key: 'id'
					}, {
						title: '媒体平台',
						key: 'name'
					},
					{
						title: '媒体类型',
						key: 'platform_type_name'
					},
					{
						title: '备注',
						key: 'remark'
					},
					{
						title: '后台查询账号',
						key: 'phone'
					},
					{
						title: '撞库接口',
						key: 'repeat_check_name'
					},
					{
						title: '入库条件',
						key: 'condition_check_name'
					},
					{
						title: '佣金比例',
						key: 'settle_type_name'
					},
					{
						title: '操作',
						slot: 'action'
					},
				],
				data: []
			}
		},
		methods: {
			...mapActions([
				'handleLogOut',
			]),
			search() {
				this.page = 1;
				this.getList();
			},
			initSearch() {
				this.name = '';
				this.page = 1;
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			async getList() {
				let that = this;
				let data = {
					token: that.token,
					page: that.page,
					name: this.name
				};
				let res = await getMediumList(that, data);
				if (res.code == 1) {
					that.data = res.data.list;
					that.count = res.count;
				}
			},
			// 添加平台
			addPlatform() {
				this.initAddPlatform();
				this.modal = true
			},
			// 编辑平台
			async editPlatform(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let data = {
					token: that.token,
					id: id
				};
				let res = await getMedium(that, data);
				if (res.code == 1) {
					that.addPlatformForm = res.data.item;
					that.modal = true;
				}
			},
			// 删除平台
			delPlatform(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								token: that.token,
								id: id
							}
							let res = await delMedium(that, data);
							if (res.code == 1) {
								that.$Message.success('删除成功');
								that.getList();
							}
						}, 1000);
					}
				})
			},
			save() {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						data: that.addPlatformForm
					};
					let res = await saveMedium(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.modal = false;
						that.initAddPlatform();
						that.getList();
					}
				}, 500)
			},
			initAddPlatform() {
				this.addPlatformForm = {
					phone_readonly: false,
					name: '',
					phone: '',
					settle_type: 1,
					settle_proportion: '',
					settle_money: '',
					platform_type: 1,
					repeat_check: -1,
					condition_check: -1,
					ext_info: {
						remark: '',
					},
					condition: {
						age_check: -1,
						age_min: '',
						age_max: '',
						loan_astrict: -1,
						money_min: '',
						entry_requirements: -1,
						requirement: [],
					},
				};
			}
		}
	}
</script>

<style scoped lang="less">
	.yl-flex {
		display: flex;
		justify-content: space-between;
		padding-bottom: 0;
	}

	.add_flex {
		display: flex;
		align-items: center;
		margin: 10px 0;
	}

	.add_title {
		margin: 0 10px;
		font-weight: bold;

	}

	.add_box {
		border: 1px solid #969696;
		padding: 10px;
	}
</style>
